import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy } from '@angular/core';
import { Observable, combineLatest, BehaviorSubject, Subject, pipe } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Pager, ParamsType } from '@app/constants';

@Component({
  selector: 'app-pager',
  templateUrl: './pager.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./pager.component.less']
})
export class PagerComponent implements OnInit, OnDestroy {

  @Input() status$!: Observable<string>;
  @Input() pager$!: Observable<Pager>;

  public init: boolean = false;

  public firstPage$ = new BehaviorSubject(true);
  public lastPage$ = new BehaviorSubject(false);
  public currentPage$ = new BehaviorSubject<string>('');

  private unsubscribe$: Subject<void> = new Subject();


  constructor() {
    
  }

  ngOnInit(): void {
    //console.log('PagerComponent canShow this ', this);

    this.pager$.pipe(takeUntil(this.unsubscribe$)).subscribe((pager: Pager) => {
      console.log('**** PagerComponent pager$ pager ', pager);
      //console.log('**** PagerComponent pager$ pager.lastPage ', pager.lastPage);

      this.firstPage$.next(pager.currentPage === 1);
      this.lastPage$.next(pager.currentPage >= pager.lastPage);
      this.currentPage$.next(pager.currentPage + '/' + pager.lastPage);

    });
  }

  ngOnDestroy(): void {
    //console.log('PagerComponent ngOnDestroy');

    this.unsubscribe$.next();
    this.unsubscribe$.complete();    
  }

  /* skip initial loading state */
  public hideTillFirsLoad = (status: string): boolean => {
    //console.log('PagerComponent canShow status ', status);

    if (!this.init && (status === 'pending' || status === 'idle')) {
      
      if (status === 'pending') {
        this.init = true;
      }
      return true;
    }
    else {
      return false;
    }
  }
  

  public getQueryParamsPrev = (pager: Pager): ParamsType => {
    //console.log('PagerComponent getQueryParamsPrev pager', pager);

    if (pager === undefined) {
      return {};
    }


    let newQueryParams = {...pager.queryParams};

    if (newQueryParams.strana) {
      delete newQueryParams.strana;
    }

    if (pager.currentPage > 2) {
      newQueryParams['strana'] = pager.currentPage - 1;
    }

    return newQueryParams;
  }

  public getQueryParamsNext = (pager: Pager): ParamsType => {
    //console.log('PagerComponent getQueryParamsNext pager', pager);

    if (pager === undefined) {
      return {};
    }


    let newQueryParams = {...pager.queryParams};

    if (newQueryParams.strana) {
      delete newQueryParams.strana;
    }

    if (pager.currentPage < pager.lastPage) {
      newQueryParams['strana'] = pager.currentPage + 1;
    }

    return newQueryParams;
  }

  public getQueryParamsAdd = (pager: Pager): ParamsType => {
    //console.log('PagerComponent getQueryParamsNext pager', pager);

    if (pager === undefined) {
      return {};
    }


    let newQueryParams = {...pager.queryParams};

    if (newQueryParams.strana) {
      delete newQueryParams.strana;
    }

    if (pager.currentPage < pager.lastPage) {
      newQueryParams['strana'] = '@' + (pager.currentPage + 1);
    }

    return newQueryParams;
  }

}
